import PropTypes from "prop-types";
import * as React from "react";
import { AddIcon, Button } from "../../../themeV2";
import DropZone from "../images/DropZone";
import CardEditor from "./CardEditor";
import css from "./create.module.css";

const ProductsPage = function ProductsPage({
  state,
  dispatch,
  uploader,
  problems,
  showErrors,
}) {
  const indexed = state.cards.map((card, index) => ({ card, index }));

  return (
    <div className={css.page}>
      <DropZone onFiles={uploader.addAsCards} />

      <ul className={css.cards}>
        {indexed.map(({ card, index }) => (
          <CardEditor
            key={card.cardId}
            card={card}
            index={index}
            otherCards={indexed.filter(
              (other) => other.card.cardId !== card.cardId,
            )}
            dispatch={dispatch}
            uploader={uploader}
            problems={problems}
            showErrors={showErrors}
          />
        ))}
      </ul>

      <div>
        <Button
          variant="outlined"
          leading={<AddIcon />}
          onClick={() => dispatch({ type: "addCard" })}
        >
          Add product
        </Button>
      </div>
    </div>
  );
};

ProductsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  problems: PropTypes.arrayOf(PropTypes.object).isRequired,
  showErrors: PropTypes.bool,
  state: PropTypes.object.isRequired,
  uploader: PropTypes.object.isRequired,
};

export default ProductsPage;
